<template>
    <VCard>
        <Loading ref="loading"></Loading>
        <FormRenderDialog ref="renderDialog" />
        <VContainer>
            <VLayout>
                <VFlex>
                    <div ref="formBuilderContainer"></div> <!-- Tinha class="formAgenda" mas overflow do containner select fica desabilitado-->
                    <VFooter app color="white" height="auto">
                        <VCard flat tile class="flex">
                            <VDivider/>
                            <VContainer grid-list-md class="py-2" fluid>
                                <VLayout wrap>
                                    <VSpacer offset-md6/>
                                    <VFlex md1>
                                        <VBtn outline small block @click="$router.go(-1)">
                                            Cancelar
                                        </VBtn>
                                    </VFlex>

                                    <VFlex md1>
                                        <VBtn outline small block
                                              @click="$refs.renderDialog.visualizar(JSON.parse(formBuilder.formData))">
                                            Visualizar
                                        </VBtn>
                                    </VFlex>
                                    <VFlex md1>
                                        <VBtn outline small block color="error" @click="limpar">Limpar</VBtn>
                                    </VFlex>
                                    <VFlex md1>
                                        <VBtn small block
                                              class="primary"
                                              @click="salvar">
                                            Salvar
                                        </VBtn>
                                    </VFlex>
                                </VLayout>
                            </VContainer>
                        </VCard>
                    </VFooter>
                </VFlex>
            </VLayout>
        </VContainer>
    </VCard>
</template>
<script>

    import jQuery from 'jquery';
    import alerts from '@/common/alerts';
    import FormRenderDialog from "./FormRenderDialog";

    import '@/formBuilderPlugins/uppypicture.js';
    import '@/formBuilderPlugins/digitalSignature.js';

    import '@/formBuilderPlugins/userData.js';
    import '@/formBuilderPlugins/comandaData.js';

    import eventos from "../../common/eventos";
    import Loading from "../Dialog/Loading";

    window.jQuery = jQuery;
    window.$ = jQuery;

    require('jquery-ui-sortable');
    require('formBuilder');

    export default {
        components: {FormRenderDialog, Loading},
        props: {
            formulario: Object
        },
        async activated(){
            if (!this.formBuilder) {
                [this.formBuilder] = await this.$refs.loading.aguardarPromises([jQuery(this.$refs.formBuilderContainer).formBuilder(this.configFormBuilder).promise]);
            }
            this.formBuilder.actions.setData(this.formulario.codigoFonte.campos);
        },
        data() {
            return {
                formBuilder: null,
                configFormBuilder: {
                    controlOrder: [
                        'header',
                        'paragraph',
                        'text',
                        'textarea',
                        'date',
                        'number',
                        'select',
                        'checkbox-group',
                        'radio-group',
                    ],
                    disableFields: [
                        'autocomplete',
                        'button',
                        'file',
                        'hidden'
                    ],
                    disabledAttrs: [
                        'access',
                        'name'
                    ],
                    editOnAdd: false,
                    i18n: {
                        locale: 'pt-BR',
                        override: {
                            'pt-BR': {
                                checkboxGroup: 'Múltipla escolha',
                                className: 'Classes',
                                copyButtonTooltip: 'Duplicar',
                                dateField: 'Data',
                                description: 'Texto de ajuda',
                                enableOther: 'Habilitar "Outros"',
                                enableOtherMsg: 'Permitir que o usuário informe uma opção fora da lista',
                                hide: 'Editar', // sim, é isso mesmo
                                inline: 'Horizontal',
                                inlineDesc: 'Listar opções horizontalmente',
                                placeholder: 'Exemplo',
                                ['placeholders.className']: 'classes CSS separadas por espaço',
                                ['placeholders.value']: 'Valor',
                                optionCount: 'Opção {count}',
                                optionValuePlaceholder: 'Valor',
                                maxlength: 'Caracteres',
                                selectionsMessage: 'Permitir selecionar mais de uma opção',
                                number: 'Número',
                                radioGroup: 'Escolha única',
                                select: 'Lista de opções',
                                subtype: 'Tipo'
                            }
                        }
                    },
                    
                    stickyControls: {
                        enable: true,
                        offset: {
                            top: 50
                        }
                    },
                    showActionButtons: false,
                    typeUserAttrs: {
                        uppypicture: {
                            minFiles: {
                                label: 'Mínimo de fotos',
                                value: 1
                            },
                            maxFiles: {
                                label: 'Máximo de fotos',
                                value: 3
                            }
                        },
                        userData: {
                            nomeCliente: {
                                label: 'Nome do Cliente',
                                value: 'Nome Exemplo'
                            },
                            dataNascimento: {
                                label: 'Data de Nascimento',
                                value: 'DD/MM/AAAA'
                            },
                            telefone: {
                                label: 'Telefone',
                                value: '0000-0000'
                            },
                            cpf: {
                                label: 'CPF',
                                value: '000.000.000-00'
                            },
                            rg: {
                                label: 'RG',
                                value: '0.000.000'
                            },
                            email: {
                                label: 'E-mail',
                                value: 'email@email.com'
                            }
                        },
                        comandaData: {
                            dataAtendimento: {
                                label: 'Data de Atendimento',
                                value: 'DD/MM/AAAA'
                            },
                            horaAtendimento: {
                                label: 'Horário de Atendimento',
                                value: '00:00'
                            },
                            numComanda: {
                                label: 'Número da Comanda',
                                value: '00000'
                            },
                            servico: {
                                label: 'Serviço',
                                value: 'Serviço Exemplo'
                            },
                            franquia: {
                                label: 'Franquia',
                                value: 'Franquia Exemplo'
                            },
                            profissionalResponsavel: {
                                label: 'Profissional Responsável',
                                value: 'Nome Profissional'
                            }
                        }
                    },
                    typeUserDisabledAttrs: {
                        uppypicture: [
                            'placeholder',
                            'value'
                        ]
                    }
                }
            }
        },
        methods: {
            salvar() {
                eventos.barramento.$emit(eventos.GRAVAR_FORMULARIO_FB, {campos: JSON.parse(this.formBuilder.formData)});
                this.$router.go(-1);
            },
            async limpar() {
                if (await alerts.pedirConfirmacao('Remover todos os campos do formulário?', 'Essa ação não poderá ser desfeita!')) {
                    this.formBuilder.actions.clearFields();
                }
            }
        },
        name: "FormBuilderDialog"
    }
</script>

<style scoped lang="scss">
    @import '~@/assets/forms.css';
</style>